<template>
<div class="box__container">
	<div class="box__header"  v-if="knowledgeTypeProp">
		<div class="box__header__title">
			<h2 v-if="knowledgeTypeProp === 'posicionamento'">
				{{ 'answerSingle' | translate | capitalize }}
			</h2>
			<h2 v-else>
				{{ knowledgeTypeProp | titleCase }}
			</h2>
		</div>
	</div>

	<div class="box__body">
		<div class="box__body__subtitle" v-if="knowledgeTypeProp">
			<p v-if="knowledgeTypeProp === 'histórico'">
				Conte aos seguidores se você já participou ou realizou alguma ação sobre este tema.
			</p>
			<p v-if="knowledgeTypeProp === 'proposta'">
				Apresente aos seguidores suas propostas e projetos sobre o tema.
			</p>
			<p v-if="knowledgeTypeProp === 'posicionamento'">
				Apresente a resposta adequada para esta intenção. Procure ser amplo e conciso nas suas respostas focando na intenção do seguidor
			</p>
		</div>

		<form @submit.prevent="knowledgeRegister" id="greet">
			<div class="form__group">
				<label for="reply">{{ 'text-reply' | translate | capitalize }}</label>
				<textarea id="send-message" @input="count($event, 2000)" maxlength="2000" v-model="knowledgeAnswer"></textarea>
				<span id="counter-send-message" class="label pull-right bg-red counter"></span>
			</div>
			<div class="form__group">
				<div class="form__group__title">
					<label :for="'upload-file-' + knowledgeIndexProp">
						{{ 'file-reply' | translate | capitalize }}
					</label>
					<p class="label-subtitle">
						{{ 'send-file-instructions' | translate | capitalize }}
					</p>
				</div>
				<div class="form__group__uploader">
					<input type="text"  :placeholder="fileName" class="form__group__uploader--disabled" disabled>
					<label :for="'upload-file-' + knowledgeIndexProp" class="form__group__uploader__label">
						<input
						:id="'upload-file-' + knowledgeIndexProp"
						type="file"
						ref="fileupload"
						name="file"
						@change="handleFileUpload($event)"
						accept="image/*, video/*, audio/* video/mp4,video/x-m4v, .mov, .mp4, .x-m4v, .mp3, .png, .gif, .wav, .m4v">
						<!-- {{ 'select' | translate | capitalize }} -->
						<span id="file-selected"></span>
					</label>
					<div v-if="this.selectedFile" @click="resetFile()" class="form__group__remove-attachment">
						<i class="fas fa-times"></i>
						{{ 'remove-attachment' | translate | titleCase }}
					</div>
				</div>
				<div v-if="knowledgeSavedAttachmentIdProp || knowledgeSavedAttachmentTypeProp" class="has-attachment">
					<label v-if="removeAttachment">{{ 'attachment-will-be-removed-on-save' | translate }}</label>
					<label v-else>{{ 'knowledge-with-attachment' | translate }}</label>
					<a
						href=""
						class="text-like"
						v-if="!removeAttachment"
						@click.prevent="removeAttachment = true"
					>
						{{ 'remove-attachment' | translate }}
					</a>

					<div v-if="1 !== 1" @click="" class="form__group__remove-attachment">
						<i class="fas fa-times"></i>
						{{ 'remove-attachment' | translate | titleCase }}
					</div>
				</div>
			</div>

			<!-- <div v-if="errorMessage != ''">
				<label><i class="fas fa-times-circle-o"></i>	{{ errorMessage }}</label>
			</div> -->





			<div class="form__group">
				<label for="status">{{ 'status' | translate | capitalize }}</label>
				<select name="status" v-model="knowledgeActive">
					<option value="1">{{ $t('active', {}, 1) }}</option>
					<option value="0">{{ $t('pending', {}, 1) }}</option>
				</select>
			</div>

			<div class="form__group">
				<div class="image-preview" v-if="imageData.length > 0">
					<img class="preview" :src="imageData">
				</div>
			</div>
			<div class="form__group submit__content">
				<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
					{{ 'save' | translate | capitalize }}
				</button>
			</div>
			<div class="has-error" v-if="errorMessage != ''">
				<label><i class="fas fa-times-circle-o"></i>	{{ errorMessage }}</label>
			</div>

			<div class="has-error" v-if="validationError != ''">
				<label><i class="fas fa-times-circle-o"></i>	{{ validationError }}</label>
			</div>

			<div class="form__group has-success text-center">
				<p v-if="knowledgeForm.success">{{ 'save-with-success' | translate | capitalize }}</p>
			</div>

		</form>
	</div>

</div>
</template>
<script>
export default {
	name: 'myKnowledge',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
				intentId: this.$route.query.id,
			},
			knowledgeForm: {
				success: false,
			},
			validationError: '',
			selectedThemes: [],
			filterExists: false,
			successMsg: false,
			errorMessage: '',
			fileName: '',
			attachmentType: '',
			type: '',
			removeAttachment: false,
			imageData: '',
			selectedFile: null,
			submitLoading: false,
			knowledgeActive: this.knowledgeActiveProp,
			knowledgeAnswer: this.knowledgeAnswerProp,
		};
	},
	watch: {
		knowledgeActiveProp() {
			this.knowledgeActive = this.knowledgeActiveProp;
		},
		knowledgeAnswerProp() {
			this.knowledgeAnswer = this.knowledgeAnswerProp;
		},
	},
	props: {
		knowledgeActiveProp: {
			type: Number,
			required: true,
			default: 1,
		},
		knowledgeAnswerProp: {
			type: String,
			required: false,
		},
		knowledgeCreatedAtProp: {
			type: String,
			required: false,
		},
		knowledgeIdProp: {
			type: Number,
			required: false,
		},
		knowledgeIndexProp: {
			type: Number,
			required: true,
		},
		knowledgeSavedAttachmentIdProp: {
			type: String,
			required: false,
		},
		knowledgeSavedAttachmentTypeProp: {
			type: String,
			required: false,
		},
		knowledgeTypeProp: {
			type: String,
			required: true,
		},
		knowledgeUpdatedAtProp: {
			type: String,
			required: false,
		},
	},
	computed: {
		success() {
			return this.$store.state.status;
		},
	},
	methods: {
		resetFile() {
			this.$refs.fileupload.value = '';
			this.selectedFile = null;
			this.imageData = '';
			this.type = '';
			this.attachment_type = '';
			this.fileName = '';
		},
		count(event, tam) {
			const lengthText = document.getElementById(`counter-${event.target.id}`);
			lengthText.textContent = (event.target.value.length - tam) * -1;
		},
		handleFileUpload(event) {
			const input = event.target;
			const reader = new FileReader();

			this.imageData = '';
			if (input.files && input.files[0]) {
				this.fileSize = event.target.files[0].size;

				if (event.target.files[0].size < 26214400) {
					this.type = 'attachment';
					[this.selectedFile] = event.target.files;
					this.fileName = event.target.files[0].name;

					if ((/(image)/i).test(event.target.files[0].type)) {
						this.attachmentType = 'image';
						reader.onload = (e) => {
							this.imageData = e.target.result;
						};
						reader.readAsDataURL(input.files[0]);
					} else if ((/(audio)/i).test(event.target.files[0].type)) {
						this.attachmentType = 'audio';
					} else if ((/(video)/i).test(event.target.files[0].type)) {
						this.attachmentType = 'video';
					} else {
						this.errorMessage = 'Formato inválido';
					}
				} else {
					this.errorMessage = 'O arquivo excede o tamanho máximo permitido';
					setTimeout(() => {
						this.errorMessage = '';
					}, 4000);
				}
			}
		},
		getFormData(object) {
			const formData = new FormData();
			Object.keys(object).forEach(key => formData.append(key, object[key]));
			return formData;
		},
		knowledgeRegister() {
			if (this.knowledgeAnswer || this.selectedFile) {
				this.erro = false;

				const payload = {};

				if (this.removeAttachment) {
					payload.delete_attachment = 1;
				}

				payload.active = this.knowledgeActive;
				payload.type = this.knowledgeTypeProp;

				if (this.selectedFile) {
					payload.file = this.selectedFile;
					this.validationError = 'Anexar arquivos de mídia pode levar alguns minutos. Por favor, não feche esta janela enquanto estiver subindo mídia';
				}

				if (this.knowledgeAnswer) {
					payload.answer = this.knowledgeAnswer;
				}

				this.toggleSubmitLoading();

				if (this.knowledgeIdProp) {
					payload.myKnowledgeId = this.knowledgeIdProp;
					this.$store.dispatch('editKnowledge', this.getFormData(payload))
						.then(() => {
							this.validationError = '';
							this.toggleSubmitLoading();
							this.knowledgeForm.success = this.success;

							if (this.removeAttachment) {
								this.knowledgeSavedAttachmentIdProp = null;
								this.knowledgeSavedAttachmentTypeProp = null;
							}
							setTimeout(() => {
								this.knowledgeForm.success = false;
							}, 5000);
						})
						.catch(() => {
							this.validationError = '';
							this.toggleSubmitLoading();
						});
				} else {
					payload.entity_id = this.$route.query.id;

					this.$store.dispatch('newKnowledge', this.getFormData(payload))
						.then(() => {
							this.validationError = '';
							this.toggleSubmitLoading();
							this.knowledgeForm.success = this.success;
							setTimeout(() => {
								this.knowledgeForm.success = false;
							}, 5000);
							this.$store.dispatch('getIntent', this.session)
								.then(() => {
									this.toggleLoading();
								})
								.catch(() => {
									this.toggleLoading();
								});
						})
						.catch(() => {
							this.validationError = '';
							this.toggleSubmitLoading();
						});
				}
			} else {
				this.validationError = 'Você deve preencher algum posicionamento';
				setTimeout(() => {
					this.validationError = '';
				}, 5000);
			}
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
		toggleSubmitLoading() {
			this.submitLoading = !this.submitLoading;
		},
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/entity/myKnowledge.vue